// @flow

import React, { type Node } from 'react';
import { getGatewayVoucherCode, usePendingIncomingPayment, getCountry} from '@tectonics/prs/incoming-payment';
import Barcode from 'react-barcode';
import styled from 'styled-components';
import { SectionTitle } from '../../../../commons/atoms';

export function CashBarcode(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <section>
      <SectionTitle>
        <TitleMessageByCountry />
      </SectionTitle>
      <BarcodeWrapper>
        <Barcode format="CODE128" value={getGatewayVoucherCode(incomingPayment)} displayValue={false} height={50} />
      </BarcodeWrapper>
    </section>
  );
}

function TitleMessageByCountry(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);

  switch(country) {
    case 'ar':
      return 'Usa esto código para realizar tu pago:';
    case 'mx':
      return 'Dictale estos números para el cajero OXXO para realizar tu pago:';

    default:
      throw new Error(`Cash Barcode: No title message for country ${country}`);
  }
}

const BarcodeWrapper = styled.div`
  svg {
    width: 100%;
    height: 100%;
    margin: 0.8em 0;
  }
  width: 100%;
`;
